module.exports = __webpack_public_path__ + "img/1.f58ee1e8.png";